
import React, {useEffect, useState} from "react";
import queryString from 'query-string';
import history from "../../history";
import * as util from '../Helpers/Util';

import muellifGuncelleListesi from "../../services/muellifGuncelleListesi";
import muellifKullaniciListesi from '../../services/muellifKullaniciListesi';
import basvuruMuellifBuroDegistir from '../../services/basvuruMuellifBuroDegistir';
import {Card,Row,Col,message,Spin,Form,Input,Select,Button,Tooltip as TooltipAnd} from 'antd';

import {ebBasvuruMuellifYetkiEnum,kodEbBasvuruMuellifYetkiEnum} from '../Helpers/Enum';
const { Option } = Select;

const parsed = queryString.parse(history.location.search);

const layout = {
    labelCol: { xs: { span: 24 }, sm: { span: 12 }, md: { span: 8 }, lg: { span: 8 } },
    wrapperCol: { xs: { span: 24 }, sm: { span: 12 }, md: { span: 12 }, lg: { span: 12 } }
}

const formItemStyle = {
    marginLeft : 10
}
const formLayout = {
    labelCol : {
        span : 4
    },
    wrapperCol : {
        span : 8
    }
}

const MuellifGuncelleForm = () => {

    const [spining, setSpining] = useState(true);
    const [form] = Form.useForm();

    const [muellifGuncelleData , setMuellifGuncelleData] = useState([]);

    const load = async () => {

        var dataList = [];
        
        await muellifGuncelleListesi(parsed).then(async resp => {
            if(resp.data.success){
                var result = resp.data.result;
                
                await result.map(key => {
                    var data = [];
                    var dataFilter = dataList.filter(e => e.basvuruMuellifYetkiId == key.basvuruMuellifYetkiId);
                    
                    if(dataFilter.length > 0){    
                       dataFilter[0].basvuruMuellifYetkiList.push({
                            muellifYetkiAltSurecTipiId : key.muellifYetkiAltSurecTipiId,
                            muellifYetkiAltSurecTipiAdi : key.muellifYetkiAltSurecTipiAdi,
                            muellifBuroId : key.muellifSecimKontrol.muellifBuroId != null ? key.muellifSecimKontrol.muellifBuroId[0] : null,
                            isReadonly : key.muellifSecimKontrol.isReadonly,
                            basvuranKullaniciId : key.muellifSecimKontrol.basvuranKullaniciId,
                            kullaniciList : key.muellifSecimKontrol.kullaniciList,
                            muellifBuroList : key.muellifBuroList
                        });
                    }else{

                        data['basvuruMuellifYetkiId'] = key.basvuruMuellifYetkiId;
                        data['basvuruMuellifYetki'] = ebBasvuruMuellifYetkiEnum[key.basvuruMuellifYetkiId];

                        data['basvuruMuellifYetkiList'] = [{
                            muellifYetkiAltSurecTipiId : key.muellifYetkiAltSurecTipiId,
                            muellifYetkiAltSurecTipiAdi : key.muellifYetkiAltSurecTipiAdi,
                            muellifBuroId : key.muellifSecimKontrol.muellifBuroId != null ? key.muellifSecimKontrol.muellifBuroId[0] : null,
                            isReadonly : key.muellifSecimKontrol.isReadonly,
                            basvuranKullaniciId : key.muellifSecimKontrol.basvuranKullaniciId,
                            kullaniciList : key.muellifSecimKontrol.kullaniciList,
                            muellifBuroList : key.muellifBuroList
                        }]; 

                        dataList.push(data);
                    }
                });
                await setMuellifGuncelleData(dataList);          
                setSpining(false);

            }else{
                setSpining(false);
                message.error(resp.data.message);
            }
        });
    }

    useEffect(() => {
        load();
    },[]);

    const onFinish = async (e) => {
        setSpining(true);

        let formValues = form.getFieldValue();  
        let parentBasvuruId = parsed.parentBasvuruId;
        let dataList = [];
        
        let anaMuellifYetkiList = muellifGuncelleData.filter(e => e.basvuruMuellifYetkiId ==  kodEbBasvuruMuellifYetkiEnum.AnaYetkiliMuellif)[0]["basvuruMuellifYetkiList"]

        let result = true;

        if(Object.keys(formValues).length == 0){
            message.warning("Güncellenecek müellif bulunamamıştır.");
            result = false;
        }else{
            await Object.keys(formValues).map(key =>{
                if( key.indexOf("altSurecTipiId") > 0 ){
                    
                    const part = key.split("/");               
                    
                    const muellifYetkiId = parseInt(part[0].split("muellifYetkiId-")[1]);
                    const altSurecTipiId = parseInt(part[1].split("altSurecTipiId-")[1]);
                    const muellifBuroId = formValues[key];
                    
                    var data = {
                        MuellifYetkiId :  muellifYetkiId,
                        AltSurecTipiId :  altSurecTipiId,
                        MuellifBuroId : muellifBuroId ,
                        NewUserId : null
                    };

                    let basvuranKullaniciId = anaMuellifYetkiList.filter(m => m.muellifYetkiAltSurecTipiId == altSurecTipiId)[0]["basvuranKullaniciId"];
                    if(!util.isNullOrEmptyOrUndefined(basvuranKullaniciId) && muellifYetkiId == kodEbBasvuruMuellifYetkiEnum.AnaYetkiliMuellif){

                        const newUser = formValues["newUser-"+altSurecTipiId];
                        if(util.isNullOrEmptyOrUndefined(newUser)){
                            result = false;
                            message.warning("Güncellenen ana yetkili müellif büro için yeni kullanıcı seçimi yapmadan işleme devam edilemez.")
                        }else{
                            data["NewUserId"] = newUser;

                            dataList.push(data);
                        }
                    }else{
                        dataList.push(data);
                    }

                
                }              
            });

            const formField = {
                parentBasvuruId : parentBasvuruId,
                muellifUpdateList : dataList
            }

            if(result){
                await basvuruMuellifBuroDegistir(formField).then(resp => {

                    if(resp.data.success){
                        message.success('İşlem başarı ile tamamlandı.');               
                        window.parent.location.reload(); 
                    }else{
                        message.error(resp.data.message);
                    }});
                }
            }
       
        setSpining(false);


    }

    const onChangeByMuellif = async (key,basvuruMuellifYetkiId,altSurecId) => {       

        if(basvuruMuellifYetkiId ==  kodEbBasvuruMuellifYetkiEnum.AnaYetkiliMuellif){
            form.setFieldsValue({ ["newUser-"+altSurecId] : null });

            setSpining(true);
            await muellifKullaniciListesi(key).then(resp => {
               
                if(resp.data.success){
                    if(resp.data.result.length == 0){
                        message.warning("Büronun aktif kullanıcısı bulunmamaktadır.");
                        
                    }
                    muellifGuncelleData.map(mResp => {
                        if(mResp.basvuruMuellifYetkiId == 1){
                            mResp.basvuruMuellifYetkiList.map(key => {
                                if(key.muellifYetkiAltSurecTipiId == altSurecId){
                                    key.newUserList = resp.data.result;
                                }
                                
                            })
                            
                        }
            
                    })
                    
                }else{
                    message.error(resp.data.message);
                }
            });
            setSpining(false);
        }
       
    }


    return (
        <Spin tip={"Veriler Yükleniyor"} spinning={spining}>
             <Card bodyStyle={{padding: "10",fontWeight:"bold"}}>
                     Başvuru Müellifleri Güncelleme Formu
           </Card> 

           <Card bodyStyle={{padding: "10",color:'red'}}>
                NOT : Tamamlanmış başvurular için müellif güncellemez. Müellif seçimi yapılmayan süreçler için, müellif güncelleme işlemi yapılamaz. Seçilen sürece ait başvuru kendi adına ise, seçilen yeni kullanıcının
                muhatap kaydı yoksa müellif büro güncellenemez.
           </Card> 

           <Form form={form}  onFinish={onFinish} {...layout}>
           {muellifGuncelleData.map(resp => (            
            <>
                <Card bodyStyle={{padding: "10",fontWeight:"bold"}}>
                    {resp.basvuruMuellifYetki}
                </Card> 
                
                    {resp.basvuruMuellifYetkiList.map(list => (
                      
                         <Card bodyStyle={{padding: "10"}}>
                    
                
                        <Form.Item key={list.muellifYetkiAltSurecTipiId} label={list.muellifYetkiAltSurecTipiAdi} name={"muellifYetkiId-"+resp.basvuruMuellifYetkiId+"/altSurecTipiId-"+list.muellifYetkiAltSurecTipiId} style={formItemStyle}  labelAlign="left">
                        <Select
                                showSearch
                                defaultValue={list.muellifBuroId}
                                key={list.muellifBuroId}
                               onChange = {(el)=>onChangeByMuellif(el,resp.basvuruMuellifYetkiId,list.muellifYetkiAltSurecTipiId)}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                disabled={list.isReadonly}
                                >
                                {list.muellifBuroList && list.muellifBuroList.map(bt => <Option key={bt.objectid} value={bt.objectid}>{bt.adi}</Option>)}
                            </Select> 
                            
                        </Form.Item >     
                        
                        {resp.basvuruMuellifYetkiId ==  kodEbBasvuruMuellifYetkiEnum.AnaYetkiliMuellif && !util.isNullOrEmptyOrUndefined(list.basvuranKullaniciId) &&
                        
                            <Form.Item label="Kullanıcı" style={formItemStyle}  labelAlign="left">
                                <Select
                                    showSearch
                                    defaultValue={list.basvuranKullaniciId}
                                    key={list.muellifBuroId}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    disabled={true}
                                    >
                                    {list.kullaniciList && list.kullaniciList.map(bt => <Option key={bt.kullaniciId} value={bt.kullaniciId}> {bt.adi} {bt.soyadi} </Option>)}
                                </Select> 
                            </Form.Item>   

                        }

                        {resp.basvuruMuellifYetkiId ==  kodEbBasvuruMuellifYetkiEnum.AnaYetkiliMuellif && list.newUserList &&  !util.isNullOrEmptyOrUndefined(list.basvuranKullaniciId) &&
                        
                            <Form.Item key={"newUser-" +list.muellifYetkiAltSurecTipiId} name={"newUser-" + list.muellifYetkiAltSurecTipiId} label="Yeni Kullanıcı"  style={formItemStyle}  labelAlign="left">
                                <Select
                                    showSearch
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}                                   
                                    >
                                    {list.newUserList && list.newUserList.map(bt => <Option key={bt.kullanici.kullaniciId} value={bt.kullanici.kullaniciId}> {bt.kullanici.adsoyad} </Option>)}
                                </Select> 
                            </Form.Item>   

                        }


                     
                       
                        </Card> 
                    ))}
                    
               
               
                
                </>
           ))}
            <Row>
                    <Col span={12} style={{textAlign: 'right'}}>
                        <Button type="primary" htmlType="submit">
                            Kaydet
                        </Button>
                    </Col>  
                </Row>  
 </Form>
        </Spin>
    );

}

export default MuellifGuncelleForm;